import { createRequest } from 'utils/request';

import type { paths } from 'schemas/schema';

type Trivia = paths['/trivia/{slug}/'];

const getTrivia = createRequest<Trivia>('/pc/trivia/{slug}/');

export default getTrivia;
